import Constants from '../../../utils/CommonConstants';

class InviteDialogController {

    constructor(scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig, inviteDetails) {

        this._stateService = stateService;
        this._dialogService = dialogService;
        this._scope = scope;
        this._authenticationService = authenticationService;
        this._inviteDetails = inviteDetails;
        this._cartonomyConfig = cartonomyConfig;

        sessionService.loggedIn().then((loggedIn) => {
            scope.loggedIn = loggedIn;
        });

        if (scope.loggedIn) {
            // scope.username = await sessionService.getUserName();
            // scope.email = await sessionService.getUserEmail();
            sessionService.getUserName().then((username)=>{
                scope.username = username;
                return sessionService.getUserEmail();
            }).then((email)=>{
                scope.email = email;
            })
        } else {
            scope.username = inviteDetails.userName;
            scope.email = inviteDetails.userEmail;
        }
        scope.userFirstLetter = scope.username.substring(0, 1).toUpperCase();

        scope.continue = async() => this._continue();
        scope.login = () => this._login();
        scope.signup = () => this._signup();
    }

    _goToCatalog() {
        let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CART : Constants.RoutingStates.CATALOG;
        this._stateService.go(stateToGo);
    }

    async _continue() {

        if (!this._scope.loggedIn) {
            await this._authenticationService.loginWithInviteToken(this._inviteDetails);
        } else {
            this._authenticationService.onInviteAccepted();
        }

        this._goToCatalog();
        this._dialogService.hide();
    }

    _login() {
        this._dialogService.hide();
        this._authenticationService.showLoginDialog(this._scope.email).then(() => this._goToCatalog());
    }

    _signup() {
        this._dialogService.hide();
        this._authenticationService.showSignupDialog(this._scope.email).then(() => this._goToCatalog());
    }
}

export default function (inviteDetails) {
    return ['$scope', '$mdDialog', '$state', 'Session', 'AuthenticationService', 'cartonomyConfig',
        function (scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig) {
            return new InviteDialogController(scope, dialogService, stateService, sessionService, authenticationService, cartonomyConfig, inviteDetails);
        }];
}



// WEBPACK FOOTER //
// ./src/modules/order/controllers/InviteDialogController.js